import { useState } from 'react';
import { useAuthentication } from 'src/features/authentication/context';
import { Protected } from 'src/features/protected-route/components';
import { LoginLayout } from 'src/layouts';
import { LoginPage } from '../../pages';
import { ElementProps } from '../../types/element';
import { LoadingElement } from '../LoadingElement';
import { TENANT_SWITCH_PATH } from '../../config';
import { useLocation } from 'react-router-dom';
import { AuthStep } from 'src/types/authentication/authentication';

type LoginRouteProps = {
  step: AuthStep;
  onSetStep: (step: AuthStep) => void;
  getUser: () => any;
};

const LoginRouteElement = ({ step, onSetStep, getUser }: LoginRouteProps) => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const reason = queryParams.get('reason');
  return (
    <Protected
      isAuthenticated={!getUser() || reason === 'logout' || step !== 'login'}
      isAuthorized={true}
      uniqueRedirectPath={TENANT_SWITCH_PATH}
    >
      <LoginLayout>
        <LoginPage step={step} onSetStep={onSetStep} />
      </LoginLayout>
    </Protected>
  );
};

export const LoginElement = ({ isSuperAdmin }: ElementProps) => {
  const { loggedIn, getUser } = useAuthentication();
  const [step, setStep] = useState<AuthStep>('login');

  if (!loggedIn.loaded) {
    return <LoadingElement />;
  }

  return (
    <LoginRouteElement
      step={step}
      onSetStep={(newStep) => {
        const isChallengeStep =
          newStep === 'mfa-totp-challenge' ||
          newStep === 'mfa-sms-challenge' ||
          newStep === 'auth-method' ||
          newStep === 'text-mfa' ||
          newStep === 'auth-app';
        setStep(isChallengeStep ? newStep : 'login');
      }}
      getUser={getUser}
    />
  );
};
